import { MAX_RECENT_MODELS } from 'helpers/globals'
import findAllButById from 'helpers/findAllButById'
import { findLowestScore } from 'helpers/cameras/computeRecentScore'

export default function addRecentModel(state, action) {
  const { modelId, now, controllerModel } = action
  const { currentProjectMetadata: { _id }, projects } = state

  const key = controllerModel ? 'recentDoorControllerModels' : 'recentModels'
  const recentModels = state[key]

  const recent = recentModels.find(m => m.id === modelId)

  if (recent) {
    const { projectIds } = recent
    const newProjectIds = projectIds.find(id => id === _id) ? projectIds : [ ...projectIds, _id ]

    return Object.assign({}, state, {
      [key]: [
        ...findAllButById({ state: recentModels, id: modelId }),
        { id: modelId, date: now, count: recent.count + 1, projectIds: newProjectIds }
      ]
    })
  }

  if (recentModels.length < MAX_RECENT_MODELS) {
    return Object.assign({}, state, {
      [key]: [
        ...recentModels,
        { id: modelId, date: now, count: 1, projectIds: [ _id ] }
      ]
    })
  }

  // find the lowest to replace
  const lowest = findLowestScore(recentModels, projects, now)

  return Object.assign({}, state, {
    [key]: [
      ...findAllButById({ state: recentModels, id: lowest.id }),
      { id: modelId, date: now, count: 1, projectIds: [ _id ] }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addRecentModel.js